"use client";
import Link from "next/link.js";
import { usePathname } from "next/navigation";
import Image from "next/image";
import { useState } from "react";

import logo_1 from "@/assets/images/logo/logo_01.svg";
import vibgorone from "@/assets/images/logo/VIBGYORONE_LOGO.jpg";

import { useDispatch, useSelector } from "react-redux";
import { addFilter, filterItems } from "@/redux/features/filterSlice";
import { MenuItem, MenuItems } from "@/data/dummy-data/MenuData";
import { useSession } from "next-auth/react";
import { APP_NAME, NAV_FULL_FORM, USER_ROLE } from "@/utils/enum";

const NavMenu = ({
  setExpanded,
  toogleLive,
  pathname,
  isExpanded,
  islogo,
}: any) => {
  const filter = useSelector(filterItems);
  const dispatch = useDispatch();
  const { data: session, status }: any = useSession();
  const isAuthenticated = useSelector(
    (state: any) => state.auth.isAuthenticated,
  );
  const userRoleVal = useSelector((state: any) => state.auth.userRole);
  const currentRoute = usePathname();
  const [navTitle, setNavTitle] = useState("");
  const [activeSubMenu, setActiveSubMenu] = useState<string | null>(null);
  const [activeNestedSubMenu, setActiveNestedSubMenu] = useState<string | null>(
    null,
  );

  const isMenuItemActive = (menuLink: string) => {
    return currentRoute === menuLink;
  };

  const isSubMenuItemActive = (subMenuLink: string) => {
    return currentRoute === subMenuLink;
  };

  //openMobileMenu
  const openMobileMenu = (menu: any) => {
    if (navTitle === menu) {
      setNavTitle("");
    } else {
      setNavTitle(menu);
    }
    clearRedux();
  };

  const clearRedux = () => {
    dispatch(
      addFilter({
        ...filter,
        eventSearchBox: null,
      }),
    );
    return;
  };

  const app_name: string = process.env.NEXT_PUBLIC_APP_NAME || "";

  const filteredMenuData =
    userRoleVal === USER_ROLE.AGENT
      ? [
          ...MenuItems[app_name].filter(
            (menu) =>
              menu.title === "Events" ||
              menu.title === "My Orders" ||
              menu.title === "Cart" ||
              menu.title === "Logout" ||
              menu.title == "VSPA" ||
              menu.title == "V-EMBARK" ||
              menu.title == "Tours" ||
              // menu.title == "TGIP" ||
              // menu.title == "VAFP" ||
              menu.title == "External Exams" ||
              menu.title == "VIVA CONCERT KIT" ||
              menu.title == "Summer Camp" ||
              menu.title == "Camps",
          ),
          // {  // removed here , it already exist in profile icon(header component)
          //   id: 4,
          //   has_dropdown: false,
          //   title: "My Orders",
          //   link: "/orderhistory",
          // },
        ]
      : MenuItems[app_name];

  const toggleSubMenu = (subMenuTitle: string) => {
    setActiveSubMenu((prev) => (prev === subMenuTitle ? null : subMenuTitle));
  };

  const handleLinkClick = (menu: any) => {
    if (menu.external) {
      if (menu?.openNewTab) {
        window.open(menu.link, "_blank", "noopener,noreferrer");
      } else {
        window.location.href = menu.link; // Redirect for external links
      }
    }
  };

  const getLogo = () => {
    switch (app_name) {
      case APP_NAME.VIBGYOR_VIVA:
        return logo_1;

      case APP_NAME.VIBGYOR_ONE:
        return vibgorone;
      case APP_NAME.SUMMER_CAMP_PRIVATE:
        return vibgorone;
      default:
        return logo_1;
    }
  };
  return (
    <>
      <ul className="navbar-nav align-items-lg-center">
        <li className="d-block d-lg-none">
          <div className="logo">
            <Link
              href="/"
              className="d-block"
              onClick={() => {
                const navbarCollapse = document.getElementById("navbarNav");
                if (navbarCollapse) {
                  navbarCollapse.classList.remove("show");
                }
                setExpanded(false);
              }}
            >
              <Image src={getLogo()} alt={app_name as keyof typeof APP_NAME} />
            </Link>
          </div>
        </li>
        {/* <li className="nav-item dashboard-menu">
        <Link
          className="nav-link"
          href="/dashboard/dashboard-index"
          target="_blank"
        >
          Dashboard
        </Link>
      </li> */}

        {filteredMenuData?.map((menu: MenuItem) => (
          <li
            key={menu.id}
            className={`nav-item ${menu.has_dropdown ? "dropdown" : ""} ${
              menu.class_name
            }`}
          >
            {!menu.has_dropdown ? (
              !(
                (menu.title === "Registration Details" ||
                  menu.title === "My Events" ||
                  menu.title === "My Orders" ||
                  menu.title === "My Activity") &&
                !isAuthenticated
              ) && (
                <>
                  {!(menu.link === "/live" && !toogleLive) && (
                    <div className="nav-link-wrapper d-block">
                      <Link
                        href={menu.link}
                        className={`nav-link text-nowrap d-block navbar-text ${
                          pathname === menu.link ? "active" : ""
                        }
                              ${navTitle === menu.title ? "show" : ""} ${
                                menu.link == "/live" && "text-danger"
                              }
                              ${isExpanded ? "pl-40" : "px-0"}
                              `}
                        onClick={() => {
                          openMobileMenu(menu.title);
                          const navbarCollapse =
                            document.getElementById("navbarNav");
                          if (navbarCollapse) {
                            navbarCollapse.classList.remove("show");
                          }
                          setExpanded(false);
                        }}
                      >
                        {menu.link == "/live" && (
                          <span style={{ fontSize: "1.5rem", lineHeight: "0" }}>
                            &#8226;
                          </span>
                        )}

                        {menu.title}
                        {!isExpanded &&
                          Object.keys(NAV_FULL_FORM).includes(menu.title) && (
                            <>
                              <i className="info-icon bi bi-info-circle ms-1" />

                              <span className="full-form-tooltip text-wrap">
                                {
                                  NAV_FULL_FORM[
                                    menu.title as keyof typeof NAV_FULL_FORM
                                  ]
                                }
                              </span>
                            </>
                          )}
                      </Link>
                      {/* {!isExpanded &&
                        (menu.title === "V-EMBARK" ||
                          menu.title === "VSPA") && (
                          <span className="full-form-tooltip">
                            {menu.title === "V-EMBARK"
                              ? "VIBGYOR’S – EDUCATIONAL MILESTONES BEYOND ACADEMICS REDEFINING KNOWLEDGE"
                              : "VIBGYOR SPORTS AND PERFORMING ARTS"}
                          </span>
                        )} */}
                    </div>
                  )}
                </>
              )
            ) : (
              <div
                className={`nav-link dropdown-toggle navbar-text${
                  pathname === menu.link ? "active" : ""
                }
                   ${
                     navTitle === menu.title ? "show" : ""
                   } d-block cursor-pointer
                   ${isExpanded ? "pl-40" : "px-0"}
                   `}
                onClick={() => openMobileMenu(menu.title)}
              >
                {menu.title}
                {isExpanded &&
                  (navTitle == menu.title ? (
                    <i className="bi bi-chevron-up pl-40"></i>
                  ) : (
                    <i className="bi bi-chevron-down pl-40"></i>
                  ))}
              </div>
            )}
            {menu.has_dropdown && (
              <>
                <ul
                  className={`dropdown-menu ${
                    navTitle === menu.title ? "show" : ""
                  }`}
                >
                  {menu.sub_menus &&
                    menu.sub_menus.map((sub_m, i: any) => (
                      <li
                        key={i}
                        className={`submenu-item position-relative ${
                          pathname === sub_m.link ? "active" : ""
                        } py-0`}
                        onMouseEnter={() => {
                          toggleSubMenu(sub_m.title);
                          // Reset nested submenu when hovering over a new submenu
                          setActiveNestedSubMenu(null);
                        }}
                        onMouseLeave={() => {
                          setActiveSubMenu(null);
                          setActiveNestedSubMenu(null);
                        }}
                      >
                        <Link
                          href={
                            !menu.external
                              ? sub_m.section
                                ? `${menu.link}#${sub_m.link}`
                                : sub_m.link
                              : ""
                          }
                          className={`dropdown-item navbar-text${
                            pathname === sub_m.link ? "active" : ""
                          }`}
                        >
                          <span
                            onClick={() => {
                              sub_m.external && handleLinkClick(sub_m);
                              if (isExpanded) {
                                // when mobile, clicking on sublink will close sidebar
                                const navbarCollapse =
                                  document.getElementById("navbarNav");
                                if (navbarCollapse) {
                                  navbarCollapse.classList.remove("show");
                                }
                                setExpanded(false);
                              }
                            }}
                          >
                            {sub_m.title}
                          </span>
                        </Link>
                        {sub_m.nested_sub_menus &&
                          sub_m.has_dropdown &&
                          (activeSubMenu === sub_m.title ||
                            activeNestedSubMenu === sub_m.title) && (
                            <ul
                              className="nested-submenu"
                              onMouseEnter={() => {
                                setActiveNestedSubMenu(sub_m.title);
                              }}
                              onMouseLeave={() => {
                                setActiveNestedSubMenu(null);
                                setActiveSubMenu(null);
                              }}
                            >
                              {sub_m.nested_sub_menus.map((nested, j) => (
                                <li
                                  key={j}
                                  className={`nested-submenu-item ${
                                    pathname === nested.link ? "active" : ""
                                  }`}
                                >
                                  {nested.redirect ? (
                                    <Link
                                      className="nested-submenu-link"
                                      href={
                                        sub_m.section
                                          ? `${menu.link}#${nested.link}`
                                          : `${sub_m.link}#${nested.link}`
                                      }
                                    >
                                      {nested.title}
                                    </Link>
                                  ) : (
                                    <span className="nested-submenu-link">
                                      {nested.title}
                                    </span>
                                  )}
                                </li>
                              ))}
                            </ul>
                          )}
                      </li>
                    ))}
                  {menu.menu_column && (
                    <li className="row gx-1">
                      {menu.menu_column.map((item: any) => (
                        <div key={item.id} className="col-lg-4">
                          <div className="menu-column">
                            <h6 className="mega-menu-title navbar-text">
                              {item.mega_title}
                            </h6>
                            <ul className="style-none mega-dropdown-list">
                              {item.mega_menus.map((mega_m: any, i: any) => (
                                <li key={i}>
                                  <Link
                                    href={mega_m.link}
                                    className={`dropdown-item navbar-text ${
                                      pathname === mega_m.link ? "active" : ""
                                    }`}
                                  >
                                    <span>{mega_m.title}</span>
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      ))}
                    </li>
                  )}
                </ul>
              </>
            )}
          </li>
        ))}
      </ul>
      <style>{`
      .nav-link-wrapper {
        position: relative;
        display: inline-block;
      }

      .full-form-tooltip {
        visibility: hidden;
        width: max-content;
        max-width: 300px;
        color: #fff !important;
        background: #b3b6ba;
        text-align: center;
        border-radius: 6px;
        padding: 5px 10px;
        position: absolute;
        z-index: 1000;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        font-size: 0.9rem;
        opacity: 0;
        transition: opacity 0.2s ease;
      }

      .nav-link-wrapper.nav-link {
        display: inline-block;
      }

      .submenu-item {
        position: relative;
      }

      .nested-submenu {
        position: absolute;
        right: 100%;
        top: 0;
        min-width: 300px;
        width: max-content;
        max-width: 500px;
        background: white;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        z-index: 1000;
        padding: 0;
        margin: 0;
        display: flex;
        flex-direction: column;
      }

      .nested-submenu-item {
        padding: 5px 15px;
        cursor: pointer;
        list-style: none;
      }

      .nested-submenu-link {
        color: inherit;
        display: block;
        width: 100%;
      }

      .nested-submenu-item:hover .nested-submenu-link,
      .nested-submenu-item:hover {
        color: #fff !important;
        background: #4541D1;
      }

      .submenu-item:hover .nested-submenu {
        display: block;
      }
      
      .info-icon:hover ~ .full-form-tooltip {
        visibility: visible;
        opacity: 1;
      }

      /* use for responsive font size */
      .navbar-text {
        font-size: 16px !important;
      }

      @media (max-width: 1553px) {
        .navbar-text {
          font-size: 12px !important;
        }
      }

      @media (max-width: 768px) {
        .navbar-text {
          font-size: 13px !important;
        }
      }

     
`}</style>
    </>
  );
};

export default NavMenu;
